export const getAllPermissions = () => {
  const user = JSON.parse(sessionStorage.getItem('user'))
  const permissionData = user?.buttonPermissions ?? []
  if (user && user.menuPermissions) {
    const menuPermissions = user.menuPermissions.map((item) => item.code)
    permissionData.push(...menuPermissions)
  }
  return permissionData
}

export const hasPermission = (...keys) => {
  const permissions = getAllPermissions()
  if (Array.isArray(keys)) {
    for (const key of keys) {
      if (permissions.includes(key)) {
        return true
      }
    }
  }
  return false
}

// tribe 审批权限
const TRIBE_APPROVAL = 'TRIBE_APPROVAL'
// tribe 编辑权限
const TRIBE_EDIT = 'TRIBE_EDIT'

// campaign 审批权限
const CAMPAIGN_APPROVAL = 'CAMPAIGN_APPROVAL'
// campaign 编辑权限
const CAMPAIGN_EDIT = 'CAMPAIGN_EDIT'

// PGC 审批权限
const PGC_APPROVAL = 'PGC_APPROVAL'
// PGC 编辑权限
const PGC_EDIT = 'PGC_EDIT'
const PGC_ADD_TAG = 'PGC_ADD_TAG'
const PGC_DEL_TAG = 'PGC_DEL_TAG'
const UGC_ADD_TAG = 'UGC_ADD_TAG'
const UGC_DEL_TAG = 'UGC_DEL_TAG'

// lottery 审批权限
const LOTTERY_APPROVAL = 'LOTTERY_APPROVAL'
// lottery 编辑权限
const LOTTERY_EDIT = 'LOTTERY_EDIT'

// notification 新建权限
const NOTIFICATION_ADD = 'NOTIFICATION_ADD'

const MEC_TAG = 'MEC_TAG'
const MEC_TAG_NEW = 'MEC_TAG_NEW'
const MEC_TAG_EDIT = 'MEC_TAG_EDIT'
const MEC_TAG_DEL = 'MEC_TAG_DEL'

export const TribePermissions = {
  TRIBE_APPROVAL,
  TRIBE_EDIT,
}

export const CampaignPermissions = {
  CAMPAIGN_APPROVAL,
  CAMPAIGN_EDIT,
  LOTTERY_APPROVAL,
  LOTTERY_EDIT,
}

export const ForumPermissions = {
  PGC_APPROVAL,
  PGC_EDIT,
  PGC_ADD_TAG,
  PGC_DEL_TAG,
  UGC_ADD_TAG,
  UGC_DEL_TAG,
}

export const StatisticPermissions = {
  NOTIFICATION_ADD,
}

// tag 权限
export const TagPermissions = {
  MEC_TAG,
  MEC_TAG_NEW,
  MEC_TAG_EDIT,
  MEC_TAG_DEL,
}
